import { FormElementChangeEvent } from '..';

import React, { useCallback, memo } from 'react';
import { Row } from 'antd';

import { PanelContainer, PanelProps } from '.';

import ElementList from '../form-render/element-list';
import { FormComponentType } from '../../../types/form';
import { fieldComponentRenderer } from '../form-render/default-field-renderer';

type SinglePanelProps = Omit<PanelProps, 'name' | 'value' | 'repeatable' | 'isOrderedList'>;

const PanelSingle = memo(function PanelSingle({
  path: panelPath,
  elements,
  getFormData,
  fieldRenderer,
  errors,
  disabled,
  hiddenFields,
  onChange,
  onBlur,
  onVisibilityChange,
  onAddItem,
  onDeleteItem,
  correctionComments,
  multiDocUploadInProgress,
  setMultiDocUploadInProgress,
}: SinglePanelProps) {
  const defaultFieldRenderer = useCallback(
    (type: FormComponentType, attributes: any, error: any, Comp: React.ComponentType<any>) => {
      attributes.disabled = disabled;
      return fieldComponentRenderer(type, attributes, error, Comp);
    },
    [disabled]
  );

  const handleOnChange = useCallback(
    (event: FormElementChangeEvent) => {
      if (onChange) {
        const { name, value, path = `${panelPath}.${name}` } = event;
        onChange({ name, value, path });
      }
    },
    [onChange, panelPath]
  );

  const handleOnBlur = useCallback(
    (event: FormElementChangeEvent) => {
      if (onBlur) {
        const { name, path = `${panelPath}.${name}` } = event;
        onBlur({ name, value: getFormData(path), path });
      }
    },
    [getFormData, onBlur, panelPath]
  );

  return (
    <PanelContainer>
      <Row gutter={[16, 0]}>
        <ElementList
          path={panelPath}
          elements={elements}
          getFormData={getFormData}
          fieldRenderer={fieldRenderer || defaultFieldRenderer}
          errors={errors}
          hiddenFields={hiddenFields}
          onChangeElement={onChange && handleOnChange}
          onBlurElement={onBlur && handleOnBlur}
          onVisibilityChange={onVisibilityChange}
          onAddItem={onAddItem}
          onDeleteItem={onDeleteItem}
          correctionComments={correctionComments}
          multiDocUploadInProgress={multiDocUploadInProgress}
          setMultiDocUploadInProgress={setMultiDocUploadInProgress}
        />
      </Row>
    </PanelContainer>
  );
});

export default PanelSingle;
